export default __webpack_public_path__ + "static/media/whitehatdao.bc194534.png";